import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',

    margin: '5px 0',
    padding: '20px'
  },
  text: {
    flex: '0.8',
    fontSize: '14px'
  },
  time: {
    fontSize: '12px',
    color: '#A1A1A1'
  }
}));

const Notification = ({ text, time, past }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.container}
      style={{
        background: past ? '#F8F8F8' : 'rgba(208, 217, 247, 0.3)'
      }}>
      <p className={classes.text}>{text}</p>
      <p className={classes.time}>{time}</p>
    </div>
  );
};

export default Notification;
